import * as types from "../action-types";

const initialState = {
    loading: false,
    paginated_categories: {
        total: 0,
        per_page: 0,
        offset: 0,
        to: 0,
        last_page: 0,
        current_page: 0,
        from: 0,
        data: [],
    },
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case types.GET_TABLE_CATEGORIES.REQUEST:
            return {
                ...state,
                loading: true,
            };
        case types.GET_TABLE_CATEGORIES.SUCCESS:
            return {
                ...state,
                loading: false,
                paginated_categories: payload
            };
        case types.GET_TABLE_CATEGORIES.FAILURE:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};
